// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AlpImageVoteTable_wrapper__8DJv5"};